<template>
  <div>
    <div class="text-13 block text-gray-500 pb-2">
      {{ label + (unit ? ` (${unit})` : '') }}
    </div>
    <div v-for="option in sortedOptions" :key="option.value" class="flex items-center gap-8">
      <div class="relative flex items-center">
        <input
          type="checkbox"
          :name="`${name}-${option.value}`"
          :checked="selectedItems.includes(option.value)"
          :value="option.value"
          @change="onCheckboxChange(option.value, $event.target.checked)"
          class="rounded-6 h-16 w-16 [&:checked]:bg-primary-500 [&:checked]:border-primary-500 [&:active]:bg-primary-600 [&:hover]:border-primary-400 [&:focus]:ring-2 [&:focus]:ring-primary-500 [&:focus]:ring-offset-2 [&:focus]:outline-none"
          style="accent-color: #468641"
        />
      </div>
      <span class="text-13 text-gray-700">{{ option.label }}</span>
    </div>
    <div v-if="options.length === 0">
      <div class="text-13 w-fit align-center text-gray-500 bg-gray-100 rounded-8 p-8">No options available</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SparkMultipleSelection',
  props: {
    name: { type: String, required: true },
    label: { type: String, default: '' },
    unit: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    selectedItems() {
      return Array.isArray(this.modelValue) ? this.modelValue : [];
    },
    sortedOptions() {
      return [...this.options].sort((a, b) => a.label.localeCompare(b.label));
    },
  },
  methods: {
    onCheckboxChange(value, checked) {
      let newArray = [...this.selectedItems];
      if (checked) {
        if (!newArray.includes(value)) {
          newArray.push(value);
        }
      } else {
        newArray = newArray.filter(v => v !== value);
      }
      this.$emit('update:modelValue', newArray);
      this.$emit('change', newArray);
    },
  },
};
</script>
